if (typeof window.__divanoVariantTileGroupDefined === 'undefined') {
window.__divanoVariantTileGroupDefined = true;

class DivanoVariantTileGroup extends HTMLElement {
  static get observedAttributes() {
    return ['data-selected'];
  }

  connectedCallback() {
    this._option = this.dataset.option || '';
    this._paramKey = this.dataset.paramKey || this._option.toLowerCase();
    this._inputs = Array.from(this.querySelectorAll('input[type="radio"]'));
    this._selectionLabel = this.querySelector('[data-role="selection-label"]');

    this._onChange = this._onChange.bind(this);
    this.addEventListener('change', this._onChange);

    const url = new URL(window.location.href);
    const fromUrl = url.searchParams.get(this._paramKey);
    if (fromUrl) {
      const match = this._inputs.find((i) => i.value === fromUrl);
      if (match && !match.checked) {
        match.checked = true;
        this._syncSelectionLabel(match.value);
      }
    } else {
      const checked = this._inputs.find((i) => i.checked);
      if (checked) this._syncSelectionLabel(checked.value);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('change', this._onChange);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (!this._inputs) return;
    if (name === 'data-selected' && newValue && newValue !== oldValue) {
      const match = this._inputs.find((i) => i.value === newValue);
      if (match) match.checked = true;
      this._syncSelectionLabel(newValue);
    }
  }

  _onChange(event) {
    if (event.target.matches('input[type="radio"]')) {
      const value = event.target.value;
      this._syncSelectionLabel(value);
      this.dispatchEvent(
        new CustomEvent('divano:variant:select', {
          bubbles: true,
          detail: {
            option: this._option,
            paramKey: this._paramKey,
            value,
          },
        })
      );
    }
  }

  _syncSelectionLabel(value) {
    if (!this._selectionLabel) return;
    const matchingInput = this._inputs.find((i) => i.value === value);
    const display = matchingInput?.dataset.displayLabel || value;
    this._selectionLabel.textContent = display;
    this.setAttribute('data-selected', value);
  }
}

if (!customElements.get('divano-variant-tile-group')) {
  customElements.define('divano-variant-tile-group', DivanoVariantTileGroup);
}

}
